import { Component, OnInit, inject } from '@angular/core';
import {ResearchService} from '../../services/tools/research.service';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {Subscription} from 'rxjs';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {Utilisateur} from '../../../interface/api/Utilisateur';
import {Mandat} from '../../../class/api/Mandat';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {ToolsService} from '../../services/tools/tools.service';
import {ExUtilisateur} from '../../../class/ex/ex-utilisateur';
import {MatInput} from '@angular/material/input';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';

import {MatOption} from '@angular/material/core';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {MatSelect} from '@angular/material/select';
import {MandatsComponent} from '../mandats/mandats.component';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-modal-add-mandat',
    templateUrl: './modal-add-mandat.component.html',
    styleUrls: ['./modal-add-mandat.component.scss'],
    providers: [ResearchService],
    imports: [MatDialogTitle, MatDialogContent, MatInput, MatAutocompleteTrigger, FormsModule, MatAutocomplete, MatOption, MatTabGroup, MatTab, ReactiveFormsModule, MatSelect, MandatsComponent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalAddMandatComponent implements OnInit {
    private researchService = inject(ResearchService);
    private hydraService = inject(HydraService);
    private _formBuilder = inject(UntypedFormBuilder);
    private toolService = inject(ToolsService);
    dialogRef = inject<MatDialogRef<ModalAddMandatComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);

    public search = '';
    public utilisateurs = [];
    public utilisateurSelected: Utilisateur = null;
    private subscriptions: Subscription = null;
    private subscriptions1: Subscription[] = [];
    public _timeout = null;
    public mandat = new Mandat();

    firstFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    public mandattypes = [];
    public soustypes = [];


    public onChangeResearch(event) {
        if (this._timeout) {
            //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;
            if (
                this.search != null &&
                this.search != '' &&
                typeof this.search == 'string'
            ) {
                this.getCollection(api.experts + '?search=' + this.search + '&pagination=false');
            }
        }, 500);
    }

    public displayLabel(event) {
        if (typeof event == 'string') {
            return event;
        } else {
            if (event != null) {
                return event.nom + ' - ' + event.prenom;
            } else {
                return event;
            }
        }
    }

    public selectUser(user: Utilisateur) {
        // this.utilisateurSelected = user;
        this.hydraService.getById(user['@id']).subscribe(res => {
            this.utilisateurSelected = res;
            this.utilisateurSelected.dateNaissance = this.toolService.convertDateForFront(
                this.utilisateurSelected.dateNaissance
            );
            this.mandat.utilisateur = this.utilisateurSelected;
        });
    }

    public getCollection(url) {

        this.subscriptions = this.hydraService
            .getList(url)
            .subscribe((res: HydraCollection) => {
                let data = new HydraCollection(res).getMember();
                data = data.map(item => new ExUtilisateur(item));
                this.utilisateurs = data.filter((utilisateur: ExUtilisateur) => (utilisateur.deleted === false));
            });
    }

    getMandatType() {
        this.subscriptions1.push(
            this.hydraService
                .getList(api.mandatType, true)
                .subscribe((res: HydraCollection) => {
                    this.mandattypes = res.getMember();
                })
        );
    }

    getSousType() {
        this.subscriptions1.push(
            this.hydraService
                .getList(api.commissions, true)
                .subscribe((res: HydraCollection) => {
                    this.soustypes = res.getMember().filter(data => {
                        if (data.commissionType.code === 'CN' || data.commissionType.code === 'CS') {
                            return data;
                        }
                    });
                })
        );
    }

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    public addMandat() {
        const data = {...this.firstFormGroup.getRawValue()};
        this.mandat.dateFin = data['dateFin'];
        this.mandat.dateDebut = data['dateDebut'];
        this.mandat.mandatType = data['poste'];
        this.mandat.commission = data['sousType'];
        delete this.mandat.id;

        this.dialogRef.close(this.mandat);
    }

    ngOnInit() {
        this.firstFormGroup = this._formBuilder.group({
            nom: [''],
            prenom: [''],
            dateNaissance: [''],
            poste: ['', Validators.required],
            sousType: ['', Validators.required],
            dateDebut: ['', Validators.required],
            dateFin: ['', Validators.required],
        });
        this.getMandatType();
        this.getSousType();

        // if(this.data){
        //   this.mandat.commission = this.data;
        // }
    }

    get label() {
        return this.firstFormGroup.get('label');
    }

    get nom() {
        return this.firstFormGroup.get('nom');
    }

    get dateNaissance() {
        return this.firstFormGroup.get('dateNaissance');
    }

    get prenom() {
        return this.firstFormGroup.get('prenom');
    }

    get poste() {
        return this.firstFormGroup.get('poste');
    }

    get sousType() {
        return this.firstFormGroup.get('sousType');
    }

    get dateDebut() {
        return this.firstFormGroup.get('dateDebut');
    }

    get dateFin() {
        return this.firstFormGroup.get('dateFin');
    }
}
